// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T5avH","type":"styles_type__2GWO-","choices":"styles_choices__3EXbV"};